var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoVehicle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-5.12 -5.12 522.24 522.24",
    xmlSpace: "preserve",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.00512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 5.12
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#fc1;} "), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st1{fill:#3a4557;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.545,368.706c0,5.739,4.652,10.383,10.388,10.383h28.684c5.744,0,10.388-4.644,10.388-10.383v-21.358 h-49.459V368.706z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.987,234.003l-14.532-52.786c-7.909-28.608-33.844-48.287-63.462-48.287h-85.998 c-9.841,0-19.222,2.11-27.683,6.161l20.416,20.416c3.957-1.284,8.188-2.021,12.602-2.021h75.328 c17.753,0,33.48,11.955,38.169,29.065l5.982,21.611c0.458,1.564,0.184,3.126-0.831,4.41c-0.916,1.294-2.484,2.03-4.046,2.03 h-72.107l76.984,77.074c-1.199-2.757-1.841-5.794-1.841-9.017c0-12.324,10.024-22.347,22.441-22.347 c12.324,0,22.442,10.024,22.442,22.347c0,12.421-10.118,22.446-22.442,22.446c-3.22,0-6.252-0.646-9.014-1.931l27.871,27.961 c19.495-7.456,33.202-26.399,33.202-48.476C410.468,260.5,396.577,241.548,376.987,234.003z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.579,334.808h54.818c0.736,2.946,2.209,5.613,4.324,7.635c2.942,2.946,7.082,4.877,11.497,4.877h63.556 c3.768,0,7.172-1.284,9.93-3.494l-10.944-10.849h-62.542l-1.379-0.648l-0.646-1.382v-29.336l0.646-1.383l1.379-0.638h29.155 L146.407,192.524L135,234.003c-19.59,7.545-33.476,26.497-33.476,48.656C101.524,311.445,124.882,334.808,153.579,334.808z M153.579,260.312c12.418,0,22.441,10.024,22.441,22.347c0,12.421-10.024,22.446-22.441,22.446 c-12.323,0-22.347-10.024-22.347-22.446C131.232,270.335,141.256,260.312,153.579,260.312z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.019,74.977C390.779,28.693,326.603-0.013,256,0.005C185.398-0.013,121.221,28.693,74.982,74.977 C28.698,121.216-0.013,185.393,0,256c-0.013,70.608,28.698,134.784,74.982,181.014c46.239,46.284,110.411,75,181.018,74.981 c70.603,0.018,134.779-28.697,181.019-74.981C483.303,390.783,512.014,326.608,512,256 C512.014,185.393,483.303,121.216,437.019,74.977z M256,456.81c-55.544-0.018-105.57-22.437-142-58.814 C77.618,361.566,55.199,311.545,55.185,256c0.014-48.089,16.842-92.02,44.96-126.592l282.443,282.439 C348.016,439.969,304.086,456.793,256,456.81z M411.852,382.592L129.413,100.145C163.984,72.022,207.915,55.208,256,55.19 c55.545,0.018,105.57,22.428,141.996,58.814c36.386,36.422,58.806,86.452,58.818,141.996 C456.802,304.089,439.974,348.021,411.852,382.592z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVehicle);
export default __webpack_public_path__ + "static/media/no-vehicle.ba8764063346582d98c7a5d24ff8305a.svg";
export { ForwardRef as ReactComponent };